export default __webpack_public_path__ + "static/media/Release Notes - Caption - 08182022.4cb32ba0.pdf";